/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Inject, PLATFORM_ID, ViewChild, type OnInit } from '@angular/core';
import { CurrencyPipe, isPlatformBrowser } from '@angular/common';
import { StorageEnum } from '../../shared/enums/storage.enum';
import { AccountDetail } from '../../shared/models/account-detail';
import { UserProfile } from '../../shared/models/user-profile';
import { RateRenewal } from '../../shared/models/rate-renewal';
import { type Packages } from '../../shared/models/packages';
import { ServiceAddress } from '../../shared/models/service-address';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../shared/services/account.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { RateService } from '../../shared/services/rate.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router, RouterModule } from '@angular/router';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';

import { PerThermPipe } from '../../shared/pipes/per-therm.pipe';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RateDetailComponent } from '../rate-detail/rate-detail.component';
import { RateDetail } from '../../shared/models/rate-detail';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { FormBuilder, type FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CSRData, type Product, type RateOperand, type SSMRateOperand, type Incentive } from '../../shared/models/csr';
import { addDays, addMonths, endOfMonth, format, isWithinInterval, startOfMonth, subDays } from 'date-fns';
import { CTA, SuccessData, SuccessDetails } from '../../shared/models/success-data.model';
import { Nav } from '../../shared/enums/nav.enum';
import { catchError, concatMap, EMPTY, of, type Observable } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ErrorService } from '../../shared/services/error.service';
import { StartServiceRequest, type SSMProcessData } from '../../shared/models/start-service';
import { SsmSidePanelComponent } from '../../shared/components/ssm-side-panel/ssm-side-panel.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StartStopMoveService } from '../../shared/services/start-stop-move.service';
import { SsmStepperComponent } from '../../shared/components/ssm-stepper/ssm-stepper.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
import { CreateToDo } from '../../shared/models/create-to-do';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CustomerService } from '../../shared/services/customer.service';
import { DataViewerRequest } from '../../shared/models/smr-data-viewer-request';
import { PhoneType } from '../../shared/enums/phonetype.enum';
import { type PhoneInfo } from '../../shared/models/phone-info';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { MailingAddressService } from '../../shared/services/mailing-address.service';
import { type Operand } from '../../shared/models/operand';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationType } from '../../shared/enums/notificationtype.enum';

@Component({
  selector: 'app-rate-renewal',
  providers: [PerThermPipe, CurrencyPipe],
  templateUrl: './rate-renewal.component.html',
  styleUrl: './rate-renewal.component.scss',
  imports: [
    MatDividerModule,
    MatButtonModule,
    MatExpansionModule,
    MatCheckboxModule,
    PerThermPipe,
    RateDetailComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDialogModule,
    MatTooltipModule,
    SsmSidePanelComponent,
    SsmStepperComponent,
    PageHeaderComponent,
    RouterModule,
    NotificationComponent,
  ],
})
export class RateRenewalComponent implements OnInit {
  pageReady = false;
  isBrowser = false;
  accountDetail: AccountDetail = new AccountDetail();
  userProfile: UserProfile = new UserProfile();
  formErrorMessage?: string = '';
  pageLabels: any;
  successMessage = '';
  premiseId: string = '';
  currentAddress: ServiceAddress | undefined;
  rateResponse: any;
  rateInfo: any = {};
  oppRates: any[] = [];
  fixedRates: any[] = [];
  variableRates: any[] = [];
  sidePanelData: any;
  oppRateHeader = '';
  fixedRateHeader = '';
  variableRateHeader = '';
  cmsModelName: string = '';
  cmsPageName: string = '';
  rateForm: FormGroup;
  isRateSelected = false;
  showRateNotSelectedError = false;
  personId: string = '';
  selectedPlanData: any;
  csrProducts: Product[] = [];
  rateOperands: RateOperand[] = [];
  ssmOperands: SSMRateOperand[] = [];
  rateIncentives: Incentive[] = [];
  csrRequestId: string = '';
  @ViewChild('calculatedTooltip') calculatedTooltip: any;
  ssmData?: SSMProcessData;
  isSSMProcess = false;
  process = 'start';
  step = 3;
  headerData = new PageHeader();
  aglAccountNumber = '';
  todoAccountId = '';
  userName = '';
  mailingAddressFormData: any = {};
  responseOperands: Operand[] = [];
  isMobile = false;
  pageName = 'Rate Renewal';

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly cms: CmsService,
    private readonly currencyP: CurrencyPipe,
    private readonly rate: RateService,
    private readonly account: AccountService,
    private readonly router: Router,
    private readonly storage: StorageService,
    private readonly utils: UtilService,
    private readonly perThermP: PerThermPipe,
    private readonly fb: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly error: ErrorService,
    private readonly ssmService: StartStopMoveService,
    private readonly customer: CustomerService,
    private readonly mailingAddressService: MailingAddressService,
    private readonly seoS: SeoService,
    private readonly notifi: NotificationsService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
      this.userProfile = this.storage.getSession(StorageEnum.LoginResponse);
      this.ssmData = this.storage.getSession(StorageEnum.SSMData);
      this.userName = this.storage.getSession(StorageEnum.UserName);
      if (this.utils.isNullOrUndefined(this.accountDetail.Person)) {
        this.getPersonData();
      }
    }

    this.sidePanelData = new RateDetail();
    this.rateForm = this.fb.group({
      terms: this.fb.control<boolean>(false, [Validators.requiredTrue]),
    });

    if (!this.utils.isNullOrUndefined(this.ssmData)) {
      this.isSSMProcess = true;
      if (this.ssmData?.CurrentProcess === 'move') {
        this.process = 'move';
        this.step = 4;
      }
      if (this.ssmData?.CurrentProcess === 'reconnect') {
        this.process = 'reconnect';
        this.step = 2;
      }
    }
  }

  ngOnInit(): void {
    if (this.router.url.includes(Nav.RateChange) && !this.accountDetail.EligibileForRateChange) {
      void this.router.navigateByUrl(Nav.AccountSummary);
    } else if (this.router.url.includes(Nav.RateRenewal) && !this.accountDetail.EligibileForRenewal) {
      void this.router.navigateByUrl(Nav.AccountSummary);
    }

    if (
      this.router.url.includes('rate-change') ||
      this.router.url.includes('choose-rates') ||
      this.router.url.includes('reconnect-rates')
    ) {
      // these values will be changed in the future once we get the cms setup for rate change data
      // when those values change, make sure to add seo object to model in builder.
      // startTurnOnSuccess
      // startSwitchSuccess
      this.cmsModelName = 'oas-rate';
      this.cmsPageName = 'Rate Change';
    } else if (this.router.url.includes('rate-renewal')) {
      this.cmsModelName = 'oas-rate';
      this.cmsPageName = 'Rate Renewal';
    }
    this.cms
      .getContent(this.cmsModelName, this.cmsPageName)
      .pipe(
        concatMap((data) => {
          this.pageLabels = data;
          this.headerData.Message =
            this.ssmData?.CurrentProcess === 'start'
              ? this.pageLabels.startServiceHeader
              : this.pageLabels.rateHeaderText;
          this.seoS.setSeoTags(data.seo);

          if (this.isBrowser) {
            this.isMobile = this.utils.isMobile(992);
            if (typeof window !== 'undefined') {
              window.addEventListener('resize', () => {
                this.isMobile = this.utils.isMobile(992);
              });
            }
            if (this.isSSMProcess) {
              return this.getSSMRates();
            } else {
              return this.getRenewalRatePackages();
            }
          } else {
            return EMPTY;
          }
        }),
      )
      .subscribe((data: Packages) => {
        const saStatusFlag = this.userProfile.Accounts[0]?.ServiceAddresses?.[0]?.SaStatusFlag;
        const seasonal =
          this.userProfile.Accounts[0]?.Seasonal === true && (saStatusFlag === '60' || saStatusFlag === '70');

        if (seasonal) {
          data.RatePackages = data.RatePackages?.filter(
            (rate) => rate.ProductCode === 'VAR' || (rate.ProductCode === 'FIXED' && Number(rate.ContractLength) === 6),
          );
        } else {
          data.RatePackages = data.RatePackages?.filter((rate) => rate.ProductCode !== 'VAR');
        }

        this.rateResponse = data;
        if (data.Operands !== undefined) {
          this.responseOperands = data.Operands;
        } else {
          this.responseOperands = [{ OperandCode: '', OperandValue: '' }];
        }
        if (this.isSSMProcess && this.utils.isNullOrUndefined(this.ssmData?.RatesResponse)) {
          this.ssmData = this.storage.getSession(StorageEnum.SSMData);
        }
        if (this.isSSMProcess && this.ssmData?.RatesResponse?.EligibilityOperands !== undefined) {
          this.ssmOperands = this.ssmData?.RatesResponse?.EligibilityOperands;
        }
        this.setRateInfo(this.rateResponse.RatePackages);
        this.getProductCode();
        this.rateInfo.ProductCodes.forEach((code: any) => {
          if (code === 'OPP') {
            this.oppRates = this.getRatesForProductCode(code);
          } else if (code === 'FIXED') {
            this.fixedRates = this.getRatesForProductCode(code);
          } else if (code === 'VAR') {
            this.variableRates = this.getRatesForProductCode(code);
          }
        });
        this.setupInitialSidePanelData();
        this.setPageLabels();
        this.pageReady = true;
        this.utils.hideSpinner();
      });
  }

  setPageLabels(): void {
    const productEndDate = format(endOfMonth(new Date().toString()), 'MM/dd/yyyy');
    this.pageLabels.contentSubheader = this.pageLabels.contentSubheader.replace('$END-DATE', productEndDate);

    this.variableRateHeader = this.pageLabels.variableHeader;

    if (this.accountDetail.AccountBridgePlanStatus === 'Y') {
      this.oppRateHeader = this.pageLabels.oppHeader + ' ' + this.pageLabels.bridgeplanHeader;
    } else {
      this.oppRateHeader = this.pageLabels.oppHeader;
    }

    if (this.rateInfo.DiscountCode === 'FF') {
      this.fixedRateHeader = `${this.pageLabels.fixedRateText}<span class="discount-header"> ${this.pageLabels.ffDiscountText}</span>`;
    } else if (this.rateInfo.DiscountCode === 'SR') {
      this.fixedRateHeader = `${this.pageLabels.fixedRateText}<span class="discount-header"> ${this.pageLabels.srDiscountText}</span>`;
    } else {
      this.fixedRateHeader = this.pageLabels.fixedRateText;
    }
    if (this.accountDetail.AccountBridgePlanStatus === 'Y') {
      this.fixedRateHeader += ' ' + this.pageLabels.bridgeplanHeader;
    }

    const csf = this.currencyP.transform(this.rateResponse.RatePackages[0].CancellationFee); // Cancellation fee is the same for all packages
    this.pageLabels.oppDisclaimer = this.pageLabels.oppDisclaimer.replace('$CANCELLATION_FEE', csf);
    this.pageLabels.fixedDisclaimer = this.pageLabels.fixedDisclaimer.replace('$CANCELLATION_FEE', csf);
    this.pageLabels.variableDisclaimer = this.pageLabels.variableDisclaimer.replace('$CANCELLATION_FEE', csf);

    // have to insert button like this because it's in the middle of text
    // inserting non-standard(mat components) elements into the pagelabel and putting it as innerhtml doesnt work
    const inter = setInterval(() => {
      const insertSpan = document.getElementsByClassName('therm-tt')[0];
      if (insertSpan) {
        const ttBtn = document.getElementById('fixedThermTT');
        if (ttBtn) {
          insertSpan.appendChild(ttBtn);
          clearInterval(inter);
        }
      }
    }, 100);
  }

  getProductCode(): void {
    const rateArr: string[] = [];
    const productCodeOrder: Record<string, number> = {
      OPP: 0,
      FIXED: 1,
      VAR: 2,
    };
    this.rateResponse.RatePackages.forEach((rate: any) => {
      if (Object.prototype.hasOwnProperty.call(productCodeOrder, rate.ProductCode)) {
        rateArr.push(rate.ProductCode);
      }
    });
    if (rateArr.length > 1) {
      rateArr.sort((a, b) => {
        return (productCodeOrder[a] ?? Number.MAX_SAFE_INTEGER) - (productCodeOrder[b] ?? Number.MAX_SAFE_INTEGER);
      });
    }
    const rateSet = new Set<string>(rateArr);
    this.rateInfo.ProductCodes = rateSet;
  }

  getRatesForProductCode(productCode: string): any[] {
    const rates = this.rateResponse.RatePackages.filter((rate: any) => {
      return rate.ProductCode === productCode;
    });
    return rates.sort((a: any, b: any) => {
      return parseInt(a.ContractLength) - parseInt(b.ContractLength);
    });
  }

  setRateInfo(rates: any[] | undefined): void {
    if (rates && rates.length > 0) {
      this.rateInfo.DiscountCode = rates[0].DiscountCode;
      this.rateInfo.CSF = rates[0].CSF;
    } else {
      this.rateInfo.DiscountCode = '';
      this.rateInfo.CSF = '0';
    }
  }

  getRenewalRatePackages(): Observable<any> {
    this.currentAddress = this.storage.getSession(StorageEnum.SelectedSA);

    return this.account.GetPremiseByAddress(this.currentAddress).pipe(
      catchError((e) => {
        return EMPTY;
      }),
      concatMap((data: any) => {
        this.premiseId = data.PremiseId;
        const rateRenewalRequest = new RateRenewal();
        rateRenewalRequest.AccountNumber = this.accountDetail.AccountNumber;
        rateRenewalRequest.SaId = this.currentAddress?.SaId;
        rateRenewalRequest.PremiseId = this.premiseId;
        rateRenewalRequest.RenewalFlag = this.accountDetail.IsRenewalInProgress;
        return this.rate.getRenewalRatePackages(rateRenewalRequest).pipe(
          catchError((e) => {
            this.setRatesErrorData();
            void this.router.navigateByUrl(Nav.ErrorPage);
            return EMPTY;
          }),
        );
      }),
    );
  }

  selectRate(productCode: string, index: number, rate: any): void {
    document.querySelector('.selected')?.classList.remove('selected');

    document.querySelector(`.${productCode}-tile-${index}`)?.classList.add('selected');
    this.isRateSelected = true;
    this.showRateNotSelectedError = false;
    if (rate.ProductCode === 'OPP') {
      this.sidePanelData.PlanType = this.oppRateHeader;
      this.sidePanelData.PricePerTherm =
        this.perThermP.transform(rate.PricePerTherm) + ' ' + this.pageLabels.pricePerMonthText;
      this.sidePanelData.ProductCode = rate.ProductCode;
    } else if (rate.ProductCode === 'FIXED') {
      this.sidePanelData.PlanType = this.fixedRateHeader;
      this.sidePanelData.PricePerTherm =
        this.perThermP.transform(rate.PricePerTherm) + ' ' + this.pageLabels.pricePerThermText;
      this.sidePanelData.ProductCode = rate.ProductCode;
    } else if (rate.ProductCode === 'VAR') {
      this.sidePanelData.PlanType = this.variableRateHeader;
      this.sidePanelData.PricePerTherm =
        this.perThermP.transform(rate.PricePerTherm) + ' ' + this.pageLabels.pricePerThermText;
      this.sidePanelData.ProductCode = rate.ProductCode;
    }
    this.sidePanelData.ContractLength = rate.ContractLength + ' ' + this.pageLabels.rateTermMonthsText;
    this.sidePanelData.CustomerServiceFee = parseFloat(rate.CSF).toFixed(2);
    if (this.isSSMProcess) {
      if (this.ssmData !== undefined) {
        this.ssmData.ProductTerm = this.sidePanelData.ContractLength;
        this.ssmData.CustomerServiceFee = this.sidePanelData.CustomerServiceFee;
        this.ssmData.PackageIsOPP = this.sidePanelData.ProductCode === 'OPP';
        this.ssmData.PricePerTherm = this.sidePanelData.PricePerTherm;
        this.ssmData.PlanType = this.sidePanelData.PlanType;
      }
      this.storage.setSession(StorageEnum.SSMData, this.ssmData);
    }
    this.setSelectedPlanData(rate);
  }

  setRatesErrorData(): void {
    this.error.setErrorData('none', this.pageLabels.getRatesErrorData);
  }

  setCreateCrsErrorData(): void {
    if (!this.isSSMProcess) {
      this.error.setErrorData('none', this.pageLabels.createCsrErrorData);
    } else {
      if (this.ssmData?.CurrentProcess === 'start') {
        this.error.setErrorData('none', this.pageLabels.ssmRateErrorData);
      } else if (this.ssmData?.CurrentProcess === 'move') {
        this.error.setErrorData('none', this.pageLabels.moveCsrError);
      } else {
        this.error.setErrorData('none', this.pageLabels.reconnectCsrError);
      }
    }
  }

  confirmRenewal(): void {
    this.formErrorMessage = '';
    this.rateForm.markAllAsTouched();
    this.utils.showSpinner();
    if (this.rateForm.valid && this.isRateSelected) {
      // create and send draft CSR
      if (this.isSSMProcess) {
        this.submitDataToDataViewer();
        return;
      }
      const csrRequest: CSRData[] = this.createDraftCSR();
      this.rate.createCSR({ Customers: csrRequest }).subscribe({
        error: (e) => {
          this.utils.hideSpinner();
          this.setCreateCrsErrorData();
          void this.router.navigateByUrl(Nav.ErrorPage);
        },
        next: (data: any) => {
          const resp = data;
          this.csrRequestId = resp[0].CustomerServiceRequestId;
          this.setSuccessData();
          this.utils.rateChangeOrUpdate.set(true);
          void this.router.navigateByUrl(Nav.RateChangeSuccess);
        },
      });
    } else {
      if (!this.isRateSelected) {
        this.showRateNotSelectedError = true;
      }
      const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
      this.showFormErrorLabel(errorMessage);
      this.utils.hideSpinner();
    }
  }

  // confirmMove(): Observable<any> {
  //   const csrRequest: CSRData[] = this.createDraftCSR();
  //   return this.rate.createCSR({ Customers: csrRequest }).pipe(
  //     catchError((e) => {
  //       this.utils.hideSpinner();
  //       this.setCreateCrsErrorData();
  //       this.storage.removeSession(StorageEnum.SSMData);
  //       void this.router.navigateByUrl(Nav.ErrorPage);
  //       return EMPTY;
  //     }),
  //     concatMap((data: any) => {
  //       const resp = data;
  //       this.csrRequestId = resp[0].CustomerServiceRequestId;
  //       this.todoAccountId = resp[0].AccountId;
  //       if (this.ssmData?.StopRequest !== undefined) {
  //         return this.ssmService.stopService(this.ssmData?.StopRequest).pipe(
  //           catchError((e) => {
  //             // do error
  //             return EMPTY;
  //           }),
  //           concatMap((data: string) => {
  //             return this.createMoveToDo(this.csrRequestId, this.todoAccountId);
  //           }),
  //           concatMap((data: string) => {
  //             const emailData = this.mapMoveEmailFields();
  //             return this.ssmService.SendMoveServiceEmail(emailData);
  //           }),
  //           concatMap((data: string) => {
  //             return this.createStopCustomerContact();
  //           }),
  //           concatMap((data: string) => {
  //             return this.createMoveCustomerContact();
  //           }),
  //         );
  //       } else {
  //         return EMPTY;
  //       }
  //     }),
  //   );
  // }

  // createMoveCustomerContact(): Observable<any> {
  //   const custContact = new CreateCustomerContact();
  //   custContact.AccountNumber = this.accountDetail.AccountNumber;
  //   custContact.ContactType = 'MOVEO';
  //   custContact.Email = this.accountDetail.Email;
  //   custContact.RequestSource = 'OAS';

  //   const saturdayText = this.ssmData?.SaturdayIfAvailable ? 'Interested in Saturday service.' : '';

  //   const comments =
  //     ' Customer processed an online request to move service on ' +
  //     this.ssmData?.Date +
  //     '.' +
  //     saturdayText +
  //     'CSR# is ' +
  //     this.csrRequestId +
  //     ' GS Account Number =' +
  //     this.accountDetail.AccountNumber;
  //   custContact.Comments = comments;
  //   return this.customer.createCustomerContact(custContact);
  // }

  // createStopCustomerContact(): Observable<any> {
  //   const custContact = new CreateCustomerContact();
  //   custContact.AccountNumber = this.accountDetail.AccountNumber;
  //   custContact.ContactType = 'STOPO';
  //   custContact.Email = this.accountDetail.Email;
  //   custContact.RequestSource = 'OAS';

  //   let stopDate = this.ssmData?.StopRequest?.StopDate;
  //   if (this.ssmData?.StopRequest?.FirstAvailableText) {
  //     stopDate = this.ssmData?.StopRequest?.FirstAvailableText;
  //   }

  //   const comments =
  //     'Customer processed an online request to disconnect service at ' +
  //     stopDate +
  //     ". Requests need to be completed in AGL's system.  Start CSR: " +
  //     this.csrRequestId;
  //   custContact.Comments = comments;
  //   return this.customer.createCustomerContact(custContact);
  // }

  createMoveToDo(accountNumber: string): Observable<any> {
    const createToDo = new CreateToDo();
    createToDo.AccountNumber = this.accountDetail.AccountNumber;
    const moveDate = this.ssmData?.FirstAvailable ? new Date().toString() : this.ssmData?.Date;
    const SaturdayText = this.ssmData?.SaturdayIfAvailable === true ? 'Would prefer Saturday if possible' : '';
    createToDo.ToDoType = 'CM-STPMV';
    createToDo.ToDoRole = 'CCWEBORD';
    createToDo.Comments =
      'Requested Stop Date: ' +
      this.ssmData?.StopRequest?.StopDate +
      '; Requested Move Date: ' +
      moveDate +
      '; Source: OAS' +
      '; Reason Code Description: ' +
      this.ssmData?.StopRequest?.TurnOffReason +
      '; Special Instructions: ' +
      this.ssmData?.StopRequest?.InstructionsForMeterStop +
      '; Comments:  ' +
      this.ssmData?.StopRequest?.DetailedInstructions +
      ' ' +
      SaturdayText +
      '; Gas South Account Number: ' +
      accountNumber;

    return this.ssmData?.CurrentProcess === 'move' ? this.customer.createToDo(createToDo) : of('not move process');
  }

  setupInitialSidePanelData(): void {
    this.sidePanelData.PlanType = '';
    this.sidePanelData.Address = this.currentAddress?.Address1;
    this.sidePanelData.City = this.utils.isNullOrUndefined(this.currentAddress?.City)
      ? ''
      : this.currentAddress?.City + ', ';
    this.sidePanelData.State = this.currentAddress?.State;
    this.sidePanelData.PostalCode = this.currentAddress?.PostalCode;
  }

  setSuccessData(): void {
    const successLabels = this.pageLabels.rateChangeSuccess.value.data;
    const successData = new SuccessData();
    successData.Header = successLabels.header;
    successData.Subheader = successLabels.subheaderText;
    const acctCTA = successLabels.ctaList.find((cta: any) => {
      return cta.ctaId === 'rateChangeSuccess';
    });
    const cta = new CTA();
    cta.Label = acctCTA.ctaLabel;
    cta.AriaLabel = acctCTA.ctaAriaLabel;
    cta.Link = acctCTA.ctaUrl;
    successData.CTAList.push(cta);
    successData.Details = [];
    const detail1 = new SuccessDetails();
    detail1.Label = this.sidePanelData.ContractLength + ' ' + this.sidePanelData.PlanType + ' ';
    detail1.Value = this.sidePanelData.PricePerTherm;
    successData.Details.push(detail1);
    if (this.sidePanelData.ProductCode === 'FIXED' || this.sidePanelData.ProductCode === 'VAR') {
      const detail2 = new SuccessDetails();
      detail2.Label = successLabels.details[1].detailLabel;
      detail2.Value = this.perThermP.transform(this.sidePanelData.CustomerServiceFee);
      successData.Details.push(detail2);
    }
    const detail3 = new SuccessDetails();
    detail3.Label = successLabels.details[2].detailLabel;
    detail3.Value = this.csrRequestId;
    successData.Details.push(detail3);
    this.storage.setSession(StorageEnum.SuccessData, successData);
  }

  setMoveSuccessData(): void {
    const successLabels = this.pageLabels.moveProcessSuccess.value.data;
    const successData = new SuccessData();
    successData.Header = successLabels.header;
    successData.Subheader = successLabels.subheaderText;
    const acctCTA = successLabels.ctaList.find((cta: any) => {
      return cta.ctaId === 'rateChangeSuccess';
    });
    const cta = new CTA();
    cta.Label = acctCTA.ctaLabel;
    cta.AriaLabel = acctCTA.ctaAriaLabel;
    cta.Link = acctCTA.ctaUrl;
    successData.CTAList.push(cta);
    successData.Details = [];

    const detail7 = new SuccessDetails();
    detail7.Label = successLabels.details[6].detailLabel;
    detail7.Value = successLabels.details[6].detailValue;
    successData.Details.push(detail7);

    const detail6 = new SuccessDetails();
    detail6.Label = successLabels.details[5].detailLabel;
    detail6.Value =
      this.ssmData?.StopRequest?.StopDate !== undefined
        ? format(this.ssmData?.StopRequest?.StopDate, 'MMMM do, yyyy')
        : '';
    successData.Details.push(detail6);

    const detail5 = new SuccessDetails();
    detail5.Label = successLabels.details[4].detailLabel;
    detail5.Value = this.ssmData?.StopServiceAddress ?? '';
    successData.Details.push(detail5);

    const detail8 = new SuccessDetails();
    detail8.Label = successLabels.details[7].detailLabel;
    detail8.Value = this.formatStartDateAndTime();
    successData.Details.push(detail8);

    const detail9 = new SuccessDetails();
    detail9.Label = successLabels.details[8].detailLabel;
    detail9.Value = this.ssmData?.StartRequest?.Address1 ?? '';
    successData.Details.push(detail9);

    const detail1 = new SuccessDetails();
    detail1.Label = this.sidePanelData.ContractLength + ' ' + this.sidePanelData.PlanType + ' ';
    detail1.Value = this.sidePanelData.PricePerTherm;
    successData.Details.push(detail1);

    if (this.sidePanelData.ProductCode === 'FIXED' || this.sidePanelData.ProductCode === 'VAR') {
      const detail2 = new SuccessDetails();
      detail2.Label = successLabels.details[1].detailLabel;
      detail2.Value = this.perThermP.transform(this.sidePanelData.CustomerServiceFee);
      successData.Details.push(detail2);
    }
    // const detail3 = new SuccessDetails();
    // detail3.Label = successLabels.details[2].detailLabel;
    // detail3.Value = this.csrRequestId;
    // successData.Details.push(detail3);

    const detail4 = new SuccessDetails();
    detail4.Label = successLabels.details[3].detailLabel;
    detail4.Value = 'Paperless';
    successData.Details.push(detail4);

    this.storage.setSession(StorageEnum.SuccessData, successData);
  }

  setSSMSuccessData(): void {
    if (this.ssmData?.CurrentProcess === 'start') {
      this.setStartSuccessData();
    }
    if (this.ssmData?.CurrentProcess === 'reconnect') {
      this.setReconnectSuccessData();
    }
    if (this.ssmData?.CurrentProcess === 'move') {
      this.setMoveSuccessData();
    }
  }

  setStartSuccessData(): void {
    const successLabels =
      this.ssmData?.StartRequest?.StartServiceType === 'TO'
        ? this.pageLabels.startTurnOnSuccess.value.data
        : this.pageLabels.startSwitchSuccess.value.data;
    const successData = new SuccessData();
    successData.Header = successLabels.header;
    successData.Subheader = successLabels.subheaderText;
    const acctCTA = successLabels.ctaList.find((cta: any) => {
      return cta.ctaId === 'rateChangeSuccess';
    });
    const cta = new CTA();
    cta.Label = acctCTA.ctaLabel;
    cta.AriaLabel = acctCTA.ctaAriaLabel;
    cta.Link = acctCTA.ctaUrl;
    successData.CTAList.push(cta);
    successData.Details = [];

    // const detail1 = new SuccessDetails();
    // detail1.Label = successLabels.details[0].detailLabel;
    // detail1.Value = newAccountId;
    // successData.Details.push(detail1);

    const detail2 = new SuccessDetails();
    detail2.Label = this.sidePanelData.ContractLength + ' ' + this.sidePanelData.PlanType + ' ';
    detail2.Value = this.sidePanelData.PricePerTherm;
    successData.Details.push(detail2);
    if (this.sidePanelData.ProductCode === 'FIXED' || this.sidePanelData.ProductCode === 'VAR') {
      const detail3 = new SuccessDetails();
      detail3.Label = successLabels.details[2].detailLabel;
      detail3.Value = this.perThermP.transform(this.sidePanelData.CustomerServiceFee);
      successData.Details.push(detail3);
    }
    // const detail4 = new SuccessDetails();
    // detail4.Label = successLabels.details[3].detailLabel;
    // detail4.Value = this.csrRequestId;
    // successData.Details.push(detail4);

    const detail5 = new SuccessDetails();
    detail5.Label = successLabels.details[4].detailLabel;
    detail5.Value = this.accountDetail.IsPaperlessBilling ? 'Paperless' : 'By Mail';
    successData.Details.push(detail5);

    this.storage.setSession(StorageEnum.SuccessData, successData);
  }

  setReconnectSuccessData(): void {
    const successLabels = this.pageLabels.reconnectSuccess.value.data;
    const successData = new SuccessData();
    successData.Header = successLabels.header;
    successData.Subheader = successLabels.subheaderText;
    const acctCTA = successLabels.ctaList.find((cta: any) => {
      return cta.ctaId === 'rateChangeSuccess';
    });
    const cta = new CTA();
    cta.Label = acctCTA.ctaLabel;
    cta.AriaLabel = acctCTA.ctaAriaLabel;
    cta.Link = this.getReconnectSuccessCTAUrl();
    successData.CTAList.push(cta);
    successData.Details = [];
    const detail1 = new SuccessDetails();
    detail1.Label = this.sidePanelData.ContractLength + ' ' + this.sidePanelData.PlanType + ' ';
    detail1.Value = this.sidePanelData.PricePerTherm;
    successData.Details.push(detail1);
    if (this.sidePanelData.ProductCode === 'FIXED' || this.sidePanelData.ProductCode === 'VAR') {
      const detail2 = new SuccessDetails();
      detail2.Label = successLabels.details[1].detailLabel;
      detail2.Value = this.perThermP.transform(this.sidePanelData.CustomerServiceFee);
      successData.Details.push(detail2);
    }
    // const detail3 = new SuccessDetails();
    // detail3.Label = successLabels.details[2].detailLabel;
    // detail3.Value = this.csrRequestId;
    // successData.Details.push(detail3);

    this.storage.setSession(StorageEnum.SuccessData, successData);
  }

  showFormErrorLabel(errorMessage?: string): void {
    this.formErrorMessage = errorMessage;
    if (this.formErrorMessage && this.formErrorMessage !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }

  setSelectedPlanData(rate: any): void {
    this.selectedPlanData = {
      accountNumber: rate.AccountNumber,
      saId: rate.SaId,
      packageTerm: rate.ContractLength,
      orderCSFVal: rate.CSF,
      orderType: rate.Type,
      orderId: rate.OrderId,
      packageId: rate.PackageId,
      pricePerTherm: rate.PricePerTherm,
      evenBill: rate.EvenBill,
      discountCode: rate.DiscountCode,
      description: rate.Description,
      csrReqId: rate.CSRRequestId,
      pricePerThermUndiscounted: rate.PricePerThermUndiscounted,
    };
  }

  createDraftCSR(): CSRData[] {
    const csrRequest = new CSRData();
    const packageId = this.selectedPlanData.packageId;
    const isOPP = this.selectedPlanData.evenBill;
    const ratePerTherm = this.selectedPlanData.pricePerTherm;
    const oppAmount = isOPP ? ratePerTherm : '';
    const ratePlan = this.selectedPlanData.packageTerm;
    const custSerFee = this.selectedPlanData.orderCSFVal;
    const renewal = this.accountDetail.IsRenewalInProgress;
    const csrReqId = this.selectedPlanData.csrReqId;
    const discountCode = this.selectedPlanData.discountCode;

    let mainCustomer = '';
    let productStartDate = '';
    let productEndDate = '';

    if (renewal) {
      const todayNextMonth = addMonths(new Date(), 1);
      productStartDate = format(startOfMonth(todayNextMonth), 'MM/dd/yyyy');
      productEndDate = format(endOfMonth(new Date().toString()), 'MM/dd/yyyy');
      csrRequest.IsRenewal = renewal ? 'Y' : 'N';
    } else {
      productStartDate = format(new Date().toString(), 'MM/dd/yyyy');
      const today = addDays(new Date(), -1);
      productEndDate = format(today.toString(), 'MM/dd/yyyy'); // product end date should be a day before
      mainCustomer = 'true';
    }
    this.csrProducts = [
      {
        ProductSequence: '1',
        PreferredConnectionDate: productEndDate,
        ProductAction: 'C1ED',
        Version: '',
        RelatedProductSequence: '',
        SaId: this.selectedPlanData.saId,
        ProductId: packageId,
      },
      {
        ProductSequence: '2',
        PreferredConnectionDate: productStartDate,
        ProductAction: 'C1AD',
        Version: '',
        RelatedProductSequence: '1',
        SaId: '',
        ProductId: packageId,
      },
    ];

    this.responseOperands.forEach((element: Operand) => {
      const item: RateOperand = {
        Code: element.OperandCode,
        Value: element.OperandValue,
      };
      this.rateOperands.push(item);
    });

    this.rateIncentives = [{ Type: '', Value: '' }];

    csrRequest.PreferredConnectionDate = format(new Date().toString(), 'MM/dd/yyyy');
    csrRequest.RatePerTherm = ratePerTherm;
    csrRequest.DiscountCode = discountCode;
    csrRequest.RatePlan = ratePlan;
    csrRequest.CsrId = csrReqId;
    csrRequest.MainCustomer = mainCustomer;
    csrRequest.MainPersonId = this.utils.isNullOrWhitespace(this.accountDetail.PersonId)
      ? ''
      : this.accountDetail.PersonId;
    csrRequest.ContractDate = format(new Date().toString(), 'MM/dd/yyyy');
    csrRequest.Products = this.csrProducts;
    csrRequest.Operands = this.rateOperands;
    csrRequest.Incentives = this.rateIncentives;
    csrRequest.OppAmount = oppAmount;
    csrRequest.CustomerServiceFee = custSerFee;
    csrRequest.CustomerClass = this.accountDetail.CustomerClass;
    csrRequest.GSAccountNumber = this.accountDetail.AccountNumber;
    csrRequest.SalesChannel = this.isMobile ? 'MOBILE' : 'WEB';

    // if (this.isSSMProcess) {
    //   // csr request fields are slightly different for start/move/reconnect
    //   const ssmProducts = new Product();
    //   ssmProducts.ProductSequence = '1';
    //   ssmProducts.PreferredConnectionDate =
    //     this.ssmData?.StartRequest?.StartServiceType === 'TO'
    //       ? this.getContractStartDate()
    //       : this.getMarketSwitchStartDate();
    //   ssmProducts.ProductAction = 'C1AD';
    //   ssmProducts.Version = '';
    //   ssmProducts.RelatedProductSequence = '';
    //   ssmProducts.SaId = '';
    //   ssmProducts.ProductId = packageId;

    //   csrRequest.Products = [ssmProducts];
    //   csrRequest.MainCustomer = 'true';
    //   csrRequest.ActionMethod = 'CM-GSSTARTSERVICE';
    //   csrRequest.OrderType = 'ENROLLMENT';
    //   csrRequest.CreateProcessFlow = 'Y';
    //   csrRequest.Activate = 'Y';
    //   csrRequest.EnrollmentType = this.ssmData?.StartRequest?.StartServiceType;
    //   csrRequest.AptTimeSlot = this.ssmData?.StartRequest?.StartServiceType === 'TO' ? this.ssmData.Time : '';
    //   csrRequest.SpecialInstructions =
    //     this.ssmData?.StartRequest?.StartServiceType === 'TO' ? 'CUSTONSITE' : 'PRESENCENOT';
    //   csrRequest.CustomerType = this.accountDetail.CustomerClass === 'RES' ? 'P' : 'B';
    //   csrRequest.AccountRelationshipType = 'MAIN';
    //   csrRequest.ContractAction = ''; // 'C1AD';
    //   csrRequest.PremiseId = this.premiseId;
    //   csrRequest.ActionFlag = this.premiseId !== '' ? 'C1UP' : 'C1AD';
    //   csrRequest.PremiseAction = this.premiseId !== '' ? 'C1UP' : 'C1AD';
    //   csrRequest.SalesChannel = 'WEB';
    //   csrRequest.OverrideAddress = 'N';
    //   csrRequest.PersonSequence = '1';
    //   csrRequest.Paperless = this.accountDetail.IsPaperlessBilling ? 'Y' : 'N';
    //   csrRequest.BillFormat = 'D';
    //   csrRequest.Address = this.ssmData?.StartRequest?.Address1;
    //   csrRequest.City = this.ssmData?.StartRequest?.City;
    //   csrRequest.State = this.ssmData?.StartRequest?.State;
    //   csrRequest.Zip = this.ssmData?.StartRequest?.ZipCode;
    //   csrRequest.CsrId = this.csrRequestId;
    //   csrRequest.FirstName = this.accountDetail.FirstName;
    //   csrRequest.LastName = this.accountDetail.LastName;
    //   csrRequest.MainPersonId = this.accountDetail.Person?.PersonId;
    //   csrRequest.GCMANameMatch =
    //     this.accountDetail.GCMANameMatch === 'Y' && csrRequest.EnrollmentType === 'MKSW' ? 'Y' : 'N';
    //   csrRequest.CreateToDo = csrRequest.EnrollmentType === 'TO' ? 'Y' : csrRequest.GCMANameMatch === 'Y' ? 'N' : 'Y';
    //   csrRequest.FinanciallyResponsible = 'true';

    //   if (csrRequest.CustomerType === 'B') {
    //     const businessPhone =
    //       this.accountDetail.Person?.PhoneNumbers?.find((phone) => {
    //         return phone.IsActive && phone.IsPrimary;
    //       })?.Number ?? '';

    //     csrRequest.BusinessName = this.accountDetail.LastName;
    //     csrRequest.BusinessPhone = businessPhone;
    //   }
    //   csrRequest.AptNum = '';
    //   const email =
    //     this.accountDetail.Person?.EmailAddresses?.find((email) => {
    //       return email.IsActive && email.IsPrimary;
    //     })?.Email ?? '';
    //   csrRequest.Email = email;

    //   csrRequest.AGLQuestion1 = '';
    //   csrRequest.AGLQuestion2 = '';
    //   csrRequest.AGLQuestion3 = '';
    //   csrRequest.AGLResponse1 = '';
    //   csrRequest.AGLResponse2 = '';
    //   csrRequest.AGLResponse3 = '';
    //   csrRequest.RatePackageId = ''; // packageId;
    //   csrRequest.RatePackages = this.ssmData?.RatesResponse?.RatePackages;
    //   csrRequest.BudgetPlan = '';
    //   csrRequest.ClientAwarePotentialDelay = '';
    //   csrRequest.ClosingDate = '';
    //   csrRequest.CoApplicantDOB = '';
    //   csrRequest.CoApplicantEmail = '';
    //   csrRequest.CoApplicantFirst = '';
    //   csrRequest.CoApplicantLast = '';
    //   csrRequest.CoApplicantMiddleInitial = '';
    //   csrRequest.CoApplicantSSN = '';
    //   csrRequest.DOB = '';
    //   if (!this.ssmData?.UseServiceAddressAsMailingAddress) {
    //     if (this.ssmData?.MailingAddress?.Address2 !== '') {
    //       csrRequest.MailingAddress =
    //         this.ssmData?.MailingAddress?.Address1 + ' ' + this.ssmData?.MailingAddress?.Address2;
    //     } else {
    //       csrRequest.MailingAddress = this.ssmData?.MailingAddress?.Address1;
    //     }
    //     csrRequest.MailingCity = this.ssmData?.MailingAddress?.City;
    //     csrRequest.MailingState = this.ssmData?.MailingAddress?.State;
    //     csrRequest.MailingZip = this.ssmData?.MailingAddress?.PostalCode;
    //   } else {
    //     csrRequest.MailingAddress = '';
    //     csrRequest.MailingCity = '';
    //     csrRequest.MailingState = '';
    //     csrRequest.MailingZip = '';
    //   }
    //   if (this.ssmData?.CurrentProcess === 'reconnect') {
    //     csrRequest.MailingAddress = this.accountDetail.BillingAddress?.Address1;
    //     csrRequest.MailingCity = this.accountDetail.BillingAddress?.City;
    //     csrRequest.MailingState = this.accountDetail.BillingAddress?.State;
    //     csrRequest.MailingZip = this.accountDetail.BillingAddress?.PostalCode;
    //   }
    //   csrRequest.MiddleInitial = '';
    //   const phone = this.accountDetail.Person?.PhoneNumbers?.find((phone: PhoneInfo) => {
    //     return phone.IsActive && phone.IsPrimary;
    //   });
    //   if (phone?.Type === PhoneType.Mobile) {
    //     csrRequest.MobilePhone = phone?.Number?.replace(/-/g, '');
    //     csrRequest.PrimaryPhone = 'Mobile';
    //   } else {
    //     csrRequest.LandPhone = phone?.Number?.replace(/-/g, '');
    //     csrRequest.PrimaryPhone = 'LANDLINE';
    //   }
    //   csrRequest.PreviouslyServiced = '';
    //   csrRequest.SSN = '';
    //   csrRequest.Service = '';
    //   csrRequest.TaxID = '';
    //   csrRequest.Seasonal =
    //     this.ssmData?.CurrentProcess === 'reconnect' && this.userProfile.Accounts[0].Seasonal ? 'Y' : '';
    //   csrRequest.SalesforceId = '';
    //   csrRequest.Sequence = '1';
    //   csrRequest.ShouldReceiveBill = 'true';
    //   csrRequest.NumberOfBillCopies = '1';
    //   csrRequest.ReceiveNotification = 'true';
    //   if (this.ssmData?.UseServiceAddressAsMailingAddress) {
    //     csrRequest.BillAddressSource = 'PER';
    //   } else {
    //     csrRequest.BillAddressSource = 'ACOV';
    //   }
    //   csrRequest.PremiseSequence = '1';
    //   csrRequest.AddressOption = '';
    //   csrRequest.ContractSequence = '1';
    //   csrRequest.ContractType = '';
    //   csrRequest.ContractDate =
    //     this.ssmData?.StartRequest?.StartServiceType === 'TO'
    //       ? this.getContractStartDate()
    //       : this.getMarketSwitchStartDate();
    //   csrRequest.PreferredConnectionDate =
    //     this.ssmData?.StartRequest?.StartServiceType === 'TO'
    //       ? this.getContractStartDate()
    //       : this.getMarketSwitchStartDate();
    //   csrRequest.PromoCode = '';
    //   csrRequest.PromoCodeValue = '';
    //   csrRequest.ReferredBy = '';
    //   csrRequest.DiscountAmount = '';
    //   csrRequest.CancellationFee = '';
    //   csrRequest.BudgetBillAmount = '';
    //   csrRequest.IncentiveDescription = '';
    //   csrRequest.IncentiveTypeDescription = '';
    //   csrRequest.LocationSequence = '';
    //   csrRequest.LocationAction = '';
    //   csrRequest.ServiceLocationAction = 'C1ST';
    //   csrRequest.Distributor = '';
    //   csrRequest.Market = 'GGA';
    //   csrRequest.CountryCode = 'USA';
    //   csrRequest.CreditCheckDate = '';
    //   csrRequest.CreditBusinessScore = '';
    //   csrRequest.BusinessFailureScore = '';
    //   csrRequest.CreditDecision = '';
    //   csrRequest.BureaueCreditDescision = '';
    //   csrRequest.CreditDecision = '';
    //   csrRequest.BureaueCreditDescision = '';
    //   csrRequest.CreditScore = '';
    //   csrRequest.CreditDOB = '';
    //   csrRequest.CreditIdentifier = '';
    //   csrRequest.CreditTransactionId = '';
    //   csrRequest.KMI = false;
    //   csrRequest.SaturdayIfAvailable = this.ssmData?.SaturdayIfAvailable;

    //   csrRequest.AglAccountNumber =
    //     this.ssmData?.StartRequest?.StartServiceType === 'MKSW' ? this.aglAccountNumber : '';
    //   csrRequest.LDCNumber = this.aglAccountNumber;

    //   if (csrRequest.EnrollmentType === 'TO') {
    //     csrRequest.LocationCharacteristicName = 'N';
    //   } else {
    //     csrRequest.LocationCharacteristicName = csrRequest.GCMANameMatch === 'Y' ? 'Y' : 'N';
    //   }
    // }

    return [csrRequest];
  }

  openCalculatedTooltip(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
    this.dialog.open(this.calculatedTooltip, {
      disableClose: true,
      autoFocus: 'first-heading',
      panelClass: 'gs-dialog',
      data: {
        header: this.pageLabels.calculatedHeader,
        bodyText: this.pageLabels.calculatedBodyText,
        ctaBtnText: this.pageLabels.calculatedCtaText,
      },
    });
  }

  getSSMRates(): Observable<any> {
    let req;
    let premiseIdReq = new ServiceAddress();
    premiseIdReq.Address1 = this.ssmData?.StartRequest?.Address1;
    premiseIdReq.City = this.ssmData?.StartRequest?.City;
    premiseIdReq.State = this.ssmData?.StartRequest?.State;
    premiseIdReq.PostalCode = this.ssmData?.StartRequest?.ZipCode;
    premiseIdReq.SaId = this.ssmData?.StartRequest?.SaId;
    if (this.ssmData?.CurrentProcess === 'reconnect') {
      if (this.userProfile.Accounts[0].NumAgreements === 1) {
        premiseIdReq.Address1 = this.userProfile.Accounts[0].ServiceAddresses[0].Address1;
        premiseIdReq.Address2 = this.userProfile.Accounts[0].ServiceAddresses[0].Address2;
        premiseIdReq.City = this.userProfile.Accounts[0].ServiceAddresses[0].City;
        premiseIdReq.State = this.userProfile.Accounts[0].ServiceAddresses[0].State;
        premiseIdReq.PostalCode = this.userProfile.Accounts[0].ServiceAddresses[0].PostalCode;
        premiseIdReq.SaId = this.userProfile.Accounts[0].ServiceAddresses[0].SaId;
      } else {
        premiseIdReq = this.storage.getSession(StorageEnum.SelectedSA);
      }
    }
    this.currentAddress = premiseIdReq;
    this.currentAddress.SaId = premiseIdReq.SaId;
    return this.account.GetPremiseByAddress(premiseIdReq).pipe(
      catchError((e) => {
        return EMPTY;
      }),
      concatMap((data: any) => {
        this.premiseId = data.PremiseId;
        if (this.ssmData?.StartRequest !== undefined) {
          this.ssmData.StartRequest.AccountNumber = this.accountDetail.AccountNumber;
          this.ssmData.StartRequest.PastDueBalance = this.accountDetail.PastDueBalance;
          this.ssmData.StartRequest.SalesChannel = 'WEB';
          if (this.accountDetail.ServiceAddresses !== undefined && this.accountDetail.ServiceAddresses.length > 0) {
            this.ssmData.StartRequest.SaId = this.accountDetail.ServiceAddresses[0].SaId;
          }
          this.ssmData.StartRequest.CustomerClass = this.accountDetail.CustomerClass;
          this.ssmData.StartRequest.ActionTypeCode = 'START';
          this.ssmData.StartRequest.PromoCode =
            this.ssmData?.CurrentProcess === 'reconnect' && this.userProfile.Accounts[0].Seasonal ? 'SEASONAL' : '';
          this.ssmData.StartRequest.AddressFlag = !this.utils.isNullOrUndefined(this.ssmData.StartRequest.SaId)
            ? 'EXISTING'
            : 'NEW';
          this.ssmData.StartRequest.AuthenticatedIndicator = '';
          req = this.ssmData.StartRequest;
          req.PremiseId = this.premiseId;
        } else {
          req = new StartServiceRequest();
        }
        return this.ssmService.getStartServiceRates(req);
      }),
    );
  }

  // createSSMDraftCSRReq(): CSRData[] {
  //   const csrRequest = new CSRData();
  //   csrRequest.ActionMethod = 'CM-GSSTARTSERVICE';
  //   csrRequest.OrderType = 'ENROLLMENT';
  //   csrRequest.CreateProcessFlow = 'Y';
  //   csrRequest.CreateToDo = csrRequest.EnrollmentType === 'TO' ? 'Y' : csrRequest.GCMANameMatch === 'Y' ? 'N' : 'Y';
  //   csrRequest.Activate = 'N';
  //   csrRequest.EnrollmentType = this.ssmData?.StartRequest?.StartServiceType;
  //   csrRequest.AptTimeSlot = this.ssmData?.StartRequest?.StartServiceType === 'TO' ? this.ssmData.Time : '';
  //   csrRequest.SpecialInstructions =
  //     this.ssmData?.StartRequest?.StartServiceType === 'TO' ? 'CUSTONSITE' : 'PRESENCENOT';
  //   csrRequest.CustomerType = this.accountDetail.CustomerClass === 'RES' ? 'P' : 'B';
  //   csrRequest.AccountRelationshipType = 'MAIN';
  //   csrRequest.ContractAction = ''; // 'C1AD';
  //   csrRequest.PremiseId = this.premiseId;
  //   csrRequest.ActionFlag = this.premiseId !== '' ? 'C1UP' : 'C1AD';
  //   csrRequest.PremiseAction = this.premiseId !== '' ? 'C1UP' : 'C1AD';
  //   csrRequest.SalesChannel = 'WEB';
  //   csrRequest.OverrideAddress = 'N';
  //   csrRequest.PersonSequence = '1';
  //   csrRequest.Paperless = this.accountDetail.IsPaperlessBilling ? 'Y' : 'N';
  //   csrRequest.BillFormat = 'D';
  //   csrRequest.Address = this.ssmData?.StartRequest?.Address1;
  //   csrRequest.City = this.ssmData?.StartRequest?.City;
  //   csrRequest.State = this.ssmData?.StartRequest?.State;
  //   csrRequest.Zip = this.ssmData?.StartRequest?.ZipCode;
  //   csrRequest.GSAccountNumber =
  //     this.ssmData?.CurrentProcess === 'move' || this.ssmData?.CurrentProcess === 'reconnect'
  //       ? this.accountDetail.AccountNumber
  //       : '';
  //   csrRequest.FirstName = this.accountDetail.FirstName;
  //   csrRequest.LastName = this.accountDetail.LastName;
  //   csrRequest.MainPersonId = this.accountDetail.Person?.PersonId;
  //   csrRequest.GCMANameMatch = this.accountDetail.GCMANameMatch;
  //   csrRequest.FinanciallyResponsible = 'true';
  //   csrRequest.MainCustomer = 'true';
  //   return [csrRequest];
  // }

  getAGLInfo(): Observable<any> {
    const AGLPremiseIdToSend = this.ssmData?.StartRequest?.AGLPremiseId ?? '';
    if (AGLPremiseIdToSend !== '') {
      return this.rate.getPoolGroupByPremiseId(AGLPremiseIdToSend);
    } else {
      return of('no agl premise');
    }
  }

  formatServiceAddress(addr: ServiceAddress): string {
    const addres1 = addr.Address1 ?? '';
    const address2 = addr.Address2 ?? '';
    const city = addr.City ?? '';
    const state = 'GA';
    const zip = addr.PostalCode ?? '';
    return addres1 + ' ' + address2 + '<br>' + city + ', ' + state + ' ' + zip;
  }

  formatStartDateAndTime(): string {
    const sd = this.ssmData?.Date !== undefined ? format(this.ssmData?.Date, 'MMMM do, yyyy') : '';
    const st = this.ssmData?.Time ?? '';
    const displayTime = st === 'morning' ? '8AM to 12PM' : '12PM to 4PM';
    if (sd === '') {
      return 'First Available';
    } else {
      return sd + '<br>' + displayTime;
    }
  }

  getContractStartDate(): string {
    if (this.ssmData?.FirstAvailable) {
      const today = new Date();
      return format(today, 'MM/dd/yyyy');
    } else {
      const preferredDate = this.ssmData?.Date ?? '';
      return format(preferredDate, 'MM/dd/yyyy');
    }
  }

  getMarketSwitchStartDate(): string {
    // if current date is 19th or earlier, first day of next month, otherwise first day of two months from now
    const today = new Date();
    if (today.getDate() <= 19) {
      return format(today.setMonth(today.getMonth() + 1, 1), 'MM/dd/yyyy');
    } else {
      return format(today.setMonth(today.getMonth() + 2, 1), 'MM/dd/yyyy');
    }
  }

  mapSSMOperands(): RateOperand[] {
    const operands: RateOperand[] = [];
    if (this.ssmOperands !== undefined && this.ssmOperands.length > 0) {
      this.ssmOperands.forEach((data: SSMRateOperand) => {
        const newData: RateOperand = { Value: data.OperandValue, Code: data.OperandCode };
        operands.push(newData);
      });
    }
    return operands;
  }

  mapMoveEmailFields(): any {
    const email =
      this.accountDetail.Person?.EmailAddresses?.find((email) => {
        return email.IsActive && email.IsPrimary;
      })?.Email ?? '';

    const emailData: any = {};
    emailData.accountNumber = this.accountDetail.AccountNumber;
    emailData.contactKey = this.accountDetail.AccountNumber + email;
    emailData.customerClass = this.accountDetail.CustomerClass;
    emailData.email = email;
    emailData.apptTime = this.ssmData?.FirstAvailable ? 'First Available' : this.ssmData?.Time;
    emailData.stopServiceAddress1 = this.ssmData?.StopRequest?.ForwardingAddress?.Address1;
    emailData.stopServiceAddress2 = this.ssmData?.StopRequest?.ForwardingAddress?.Address2;
    emailData.stopServiceCity = this.ssmData?.StopRequest?.ForwardingAddress?.City;
    emailData.stopServiceState = this.ssmData?.StopRequest?.ForwardingAddress?.State;
    emailData.stopServicePostal = this.ssmData?.StopRequest?.ForwardingAddress?.PostalCode;
    emailData.startServiceAddress1 = this.ssmData?.StartRequest?.Address1;
    emailData.startServiceAddress2 = '';
    emailData.startServiceCity = this.ssmData?.StartRequest?.City;
    emailData.startServiceState = this.ssmData?.StartRequest?.State;
    emailData.startServicePostal = this.ssmData?.StartRequest?.ZipCode;
    emailData.startServiceDate = this.ssmData?.FirstAvailable ? 'First Available' : this.ssmData?.Date;
    emailData.serviceStartDate = emailData.startServiceDate;
    emailData.stopServiceDate = this.ssmData?.StopRequest?.StopDate;
    emailData.stop_date = this.ssmData?.StopRequest?.StopDate;
    emailData.startServiceType = this.ssmData?.StartRequest?.StartServiceType;
    emailData.Communication_Type = 'MOVE';
    return emailData;
  }

  getDataViewerData(): DataViewerRequest {
    const data = new DataViewerRequest();
    data.RequestType = this.getActionType();
    data.FirstName = this.accountDetail.FirstName;
    data.LastName = this.accountDetail.LastName;
    data.AccountID = this.accountDetail.AccountNumber;
    data.Seasonal = this.userProfile.Accounts[0].Seasonal ? 'True' : 'False';
    data.SaID = this.ssmData?.StartServiceAddress?.SaId;
    data.SaTypeCode = this.accountDetail.CustomerClass === 'RES' ? 'RESGAS' : 'SMLCOM';
    data.PastDueBalance = this.ssmData?.StartRequest?.PastDueBalance?.toString();
    data.ReconnectType =
      this.ssmData?.CurrentProcess === 'reconnect' && this.userProfile.Accounts[0].Seasonal ? 'SEASONAL' : '';

    const email =
      this.accountDetail.Person?.EmailAddresses?.find((email) => {
        return email.IsActive && email.IsPrimary;
      })?.Email ?? '';
    data.EmailAddress = email;
    data.AccountEmail = email;
    const phone = this.accountDetail.Person?.PhoneNumbers?.find((phone: PhoneInfo) => {
      return phone.IsActive && phone.IsPrimary;
    });

    data.PhoneNumber = phone?.Number;
    data.PhoneType = phone?.Type === PhoneType.Landline ? 'Landline' : 'Mobile';
    if (this.ssmData?.CurrentProcess === 'move') {
      let oldaddress;
      if (this.userProfile.Accounts[0].NumAgreements === 1) {
        oldaddress = this.userProfile.Accounts[0].ServiceAddresses[0];
        oldaddress.SaId = this.accountDetail.ServiceAddresses[0].SaId;
      } else {
        oldaddress = this.storage.getSession(StorageEnum.SelectedSA);
      }
      if (this.utils.isNullOrUndefined(oldaddress.FullAddress)) {
        oldaddress.FullAddress =
          oldaddress.Address1 +
          ' ' +
          oldaddress.Address2 +
          ' ' +
          oldaddress.City +
          ' ' +
          oldaddress.State +
          ' ' +
          oldaddress.PostalCode;
      }
      data.OldAddress = oldaddress;
    }
    data.TurnOffDate =
      this.ssmData?.StopRequest?.StopDate !== undefined
        ? format(this.ssmData?.StopRequest?.StopDate, 'MM/dd/yyyy')
        : '';
    data.InstructionsForMeterStop = this.ssmData?.StopRequest?.InstructionsForMeterStop;
    data.DetailedInstructions = this.ssmData?.StopRequest?.DetailedInstructions;
    data.ReasonForTurnoff = this.ssmData?.StopRequest?.TurnOffReason;
    data.ServiceType = this.ssmData?.StartRequest?.StartServiceType;
    data.StartDate = this.getDataViewerDate();
    data.TimeAvailable = this.getDataViewerTime();
    data.ServiceAddress = this.ssmData?.StartServiceAddress;
    data.MailingAddressDifferent = !this.ssmData?.UseServiceAddressAsMailingAddress;
    data.MailingAddressUseNewAddressOnAllAccounts = this.ssmData?.UseNewMailingAddressOnAllAccounts;
    if (!data.MailingAddressDifferent) {
      data.MailingAddress = this.ssmData?.StartServiceAddress;
    } else {
      if (!this.utils.isNullOrUndefined(this.ssmData?.MailingAddress?.Address1)) {
        data.MailingAddress = this.ssmData?.MailingAddress;
      } else {
        data.MailingAddress = this.accountDetail.Person?.BillingAddress;
      }
    }
    data.RaterPlanPackageId = this.selectedPlanData.packageId;
    data.RatePlanSelected = this.selectedPlanData.description;
    data.RatePlanTerm = this.selectedPlanData.packageTerm;
    data.DiscountCode = this.selectedPlanData.discountCode;
    data.OrderID = this.selectedPlanData.orderId;
    data.SortOrder = '';
    data.CustomerServiceFee = this.selectedPlanData.orderCSFVal;
    const today = new Date();
    data.ServiceRequestSubmissionTime = this.formatDateTimeForDataViewer(today);
    data.ExternalAccountId = '';
    data.Bankname = '';
    data.CardExpDate = '';
    data.CardNumber = '';
    data.CardType = '';
    data.TransferAutopay = '';
    data.TransferAuthorizedUser = '';
    data.BillDeliveryOptions = this.accountDetail.IsPaperlessBilling ? 'Y' : 'N';
    data.AuthorizedUsers = '';
    data.InstructionsForMeterStart = this.ssmData?.SaturdayIfAvailable
      ? 'User has requested a saturday appointment if possible'
      : '';
    data.BudgetBillAmount = '';
    data.ServiceAddress = this.ssmData?.StartServiceAddress;
    return data;
  }

  submitDataToDataViewer(): void {
    const dataViewerData = this.getDataViewerData();
    this.ssmService
      .saveStartMoveReconnectRequestToDataViewer(dataViewerData, this.userName)
      .pipe(
        catchError((e) => {
          this.utils.hideSpinner();
          this.setCreateCrsErrorData();
          this.storage.removeSession(StorageEnum.SSMData);
          if (this.ssmData?.CurrentProcess === 'reconnect') {
            void this.router.navigateByUrl(Nav.ReconnectError);
          } else {
            void this.router.navigateByUrl(Nav.ErrorPage);
          }
          return EMPTY;
        }),
        concatMap((data: any) => {
          // api may not error out but may return false, which is functionally same as erroring
          if (data === false) {
            this.utils.hideSpinner();
            this.setCreateCrsErrorData();
            this.storage.removeSession(StorageEnum.SSMData);
            if (this.ssmData?.CurrentProcess === 'reconnect') {
              void this.router.navigateByUrl(Nav.ReconnectError);
            } else {
              void this.router.navigateByUrl(Nav.ErrorPage);
            }
            return EMPTY;
          }
          this.setSSMSuccessData();
          return this.createMoveToDo(this.accountDetail.AccountNumber).pipe(
            concatMap((data: any) => {
              if (
                (this.ssmData?.CurrentProcess === 'move' || this.ssmData?.CurrentProcess === 'start') &&
                this.ssmData.UseServiceAddressAsMailingAddress
              ) {
                this.setupMailingAddressData();
                this.mailingAddressFormData.formGroup
                  .get('address1')
                  ?.setValue(this.ssmData.StartServiceAddress?.Address1);
                this.mailingAddressFormData.formGroup
                  .get('address2')
                  ?.setValue(this.ssmData.StartServiceAddress?.Address2);
                this.mailingAddressFormData.formGroup.get('city')?.setValue(this.ssmData.StartServiceAddress?.City);
                this.mailingAddressFormData.formGroup
                  .get('postalCode')
                  ?.setValue(this.ssmData.StartServiceAddress?.PostalCode);
                this.mailingAddressFormData.formGroup.get('state')?.setValue(this.ssmData.StartServiceAddress?.State);
                return this.mailingAddressService.updateMailingAddress(
                  this.mailingAddressFormData.formGroup,
                  this.accountDetail,
                  this.mailingAddressFormData.isMultiAccount,
                );
              } else {
                return of('do not change mailing address');
              }
            }),
            concatMap((data: any) => {
              return this.ssmService.sendStarMoveReconnectEmail(dataViewerData);
            }),
          );
        }),
      )
      .subscribe({
        next: (data: any) => {
          if (this.ssmData?.CurrentProcess === 'start') {
            this.storage.removeSession(StorageEnum.SSMData);
            void this.router.navigateByUrl(Nav.StartSuccess);
          }
          if (this.ssmData?.CurrentProcess === 'reconnect') {
            this.storage.removeSession(StorageEnum.SSMData);
            void this.router.navigateByUrl(Nav.ReconnectSuccess);
          }
          if (this.ssmData?.CurrentProcess === 'move') {
            this.storage.removeSession(StorageEnum.SSMData);
            void this.router.navigateByUrl(Nav.MoveSuccess);
          }
        },
      });
  }

  formatDateTimeForDataViewer(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  getActionType(): string {
    let res = '';
    const process = this.ssmData?.CurrentProcess;
    switch (process) {
      case 'move':
        res = 'Transfer';
        break;
      case 'start':
        res = 'Start';
        break;
      case 'reconnect':
        res = 'Reconnect';
        break;
      default:
        res = 'Start';
    }
    return res;
  }

  getPersonData(): void {
    const personReq = {
      AccountNumber: this.accountDetail.AccountNumber,
      UserName: this.accountDetail.PrimaryAccountHolder === true ? this.userName : '',
      PersonId: this.accountDetail.PersonId,
    };
    this.account.GetPerson(personReq).subscribe({
      next: (data: any) => {
        this.accountDetail.Person = data;
      },
    });
  }

  getDataViewerDate(): string {
    if (this.ssmData?.FirstAvailable === true) {
      const today = new Date();
      return format(today, 'MM/dd/yyyy');
    } else if (this.ssmData?.Date !== undefined) {
      return format(this.ssmData?.Date, 'MM/dd/yyyy');
    } else {
      return '';
    }
  }

  getDataViewerTime(): string {
    const st = this.ssmData?.Time ?? '';
    if (st === 'morning') {
      return '8AM to 12PM';
    } else if (st === 'afternoon') {
      return '12PM to 4PM';
    } else {
      return '';
    }
  }

  setupMailingAddressData(): void {
    let multi = false;
    if (this.userProfile.TotalNumAccounts && this.userProfile.TotalNumAccounts > 1) {
      multi = true;
    }
    this.mailingAddressFormData.isMultiAccount = multi;
    this.mailingAddressFormData.formGroup = this.fb.group({
      address1: [''],
      address2: [''],
      city: [''],
      postalCode: [''],
      state: ['GA'],
      setDefault: [false],
      addressRadioGroup: [''],
    });
  }

  goBack(): string {
    if (this.ssmData?.CurrentProcess === 'move') {
      return Nav.MoveServiceScheduleService;
    } else if (this.ssmData?.CurrentProcess === 'reconnect') {
      return Nav.ReconnectService;
    } else {
      return Nav.StartServiceScheduleService;
    }
  }

  getReconnectSuccessCTAUrl(): string {
    if (this.userProfile.TotalNumAccounts > 1) {
      return Nav.MultiAccountSummary;
    } else {
      const statusFlag = this.userProfile.Accounts[0].ServiceAddresses[0].SaStatusFlag;
      const isSeasonal = this.userProfile.Accounts[0].Seasonal;
      const saEndDate = this.userProfile.Accounts[0].ServiceAddresses[0].SaEndDate ?? '';
      const inInterval = isWithinInterval(new Date(saEndDate), {
        start: subDays(new Date(), 240),
        end: new Date(),
      });
      if (statusFlag === '60' || statusFlag === '70') {
        if (isSeasonal) {
          if (inInterval) {
            return Nav.Seasonal;
          } else {
            return Nav.Closed;
          }
        } else {
          return Nav.Closed;
        }
      } else {
        return Nav.AccountSummary;
      }
    }
  }
}
